<template>
    <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
      <div class="table__search-input-wrapper w-[350px] filter-search">
        <span class="pr-2 opacity-50"><search-icon /> </span>
  
        <input type="text" class="table__search-input" placeholder="Search..." />
      </div>
      
      <div id="scroller">
      
      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">DispatchID</span></label>
        <el-select filterable v-model="dispatchId" placeholder="All"
         @change="handleSelectChange('dispatchId')">
          <el-option  v-for="dispatch in dispatches" :key="dispatch.id" :label="dispatch.dispatchReference"
            :value="dispatch.dispatchReference"
            >
          </el-option>
        </el-select>
      </div>  

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">FLEET NAME</span></label>
        <el-select filterable v-model="fleetName" placeholder="All"
         @change="handleSelectChange('fleetName')">
          <el-option  v-for="dispatch in dispatches" :key="dispatch.id" :label="dispatch.consolidation.fleet.equipment"
            :value="dispatch.consolidation.fleet.equipment"
            >
          </el-option>
        </el-select>
      </div> 

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">FLEET REG NO</span></label>
        <el-select filterable v-model="regNo" placeholder="All"
         @change="handleSelectChange('regNo')">
          <el-option  v-for="dispatch in dispatches" :key="dispatch.id" :label="dispatch.consolidation.fleet.vinnumber"
            :value="dispatch.consolidation.fleet.vinnumber"
            >
          </el-option>
        </el-select>
      </div> 

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Driver</span></label>
        <el-select filterable v-model="driver" placeholder="All"
         @change="handleSelectChange('driver')">
          <el-option  v-for="dispatch in dispatches" :key="dispatch.id" :label="dispatch.consolidation.fleet.driver.firstname +  + dispatch.consolidation.fleet.driver.lastname"
            :value="dispatch.consolidation.fleet.driver.firstname +  + dispatch.consolidation.fleet.driver.lastname"
            >
          </el-option>
        </el-select>
      </div> 

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Origin</span></label>
        <el-select filterable v-model="origin" placeholder="All"
         @change="handleSelectChange('origin')">
          <el-option  v-for="dispatch in dispatches" :key="dispatch.id" :label="getLocationDetails(dispatch.consolidation.origin).locationName"
            :value="getLocationDetails(dispatch.consolidation.origin).locationName"
            >
          </el-option>
        </el-select>
      </div> 

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Destination</span></label>
        <el-select filterable v-model="destination" placeholder="All"
         @change="handleSelectChange('destination')">
          <el-option  v-for="dispatch in dispatches" :key="dispatch.id" :label="getLocationDetails(dispatch.consolidation.destination).locationName "
            :value="getLocationDetails(dispatch.consolidation.destination).locationName"
            >
          </el-option>
        </el-select>
      </div> 

    </div>
        <div class="flex items-center cursor-pointer mt-5">
        <div  @click="apply">
          <primary-button buttonText="Apply" :loading="loading" />
        </div>
        <div>
          <p @click="closeModal()" class="pl-3">Cancel</p>
        </div>
  
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
      // bookings: {
      //   required: true,
      // },
      dispatches: {
        type: Array,
        required: true,
      },
    },
  
    data() {
      return {
        
        loading: false,
       
          equipment: null,
          dispatchId: null,
      };
    },
  
    methods: {
      apply() {
        const dispatchId = this.dispatchId
        this.$emit("appliedRef", dispatchId)
     
        this.closeModal()
      },
  
      closeModal() {
        this.$emit("close-modal");
      }, 
      
  
    },
  };
  </script>
  
  <style scoped lang="scss">
    #scroller {
  max-height: 300px;
  overflow-y: auto;
}
  .label {
    @apply border-b-2 border-gray-400 w-full pb-1;
    font-size: 13px;
  }
  
  .individual-contaoner {
    @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
  }
  
  .filter-search {
    border-radius: 4px;
    @apply py-2
  }
  </style>
  